<template>
  <v-layout row wrap justify-center :class="color">
    <p class="offscreen" tabindex="0">Contenido. Se sugiere navegar con las flechas del teclado.</p>
    <ui-title-cen title="Administración del Dinero"></ui-title-cen>
    <v-flex xs12 class="text-xs-center">
      <ui-simple-lsc @hideVideo="hideVideo" :vidTittle="'Introducción'" videoEmbed="ADMINISTRACIONDINERO01.mp4"></ui-simple-lsc>
    </v-flex>
    <v-layout row justify-center>
      <v-flex sm8>
        <br>
        <p>
         En este curso usted aprenderá a <strong>administrar</strong> el dinero, tomar decisiones acertadas y  alcanzar las <strong>metas</strong> propuestas. 
         De igual manera, entenderá qué es un <strong>presupuesto</strong> y cómo elaborarlo paso a paso.
        </p>
      </v-flex>
    </v-layout>

    <v-flex xs12 text-xs-center>
      <br>
      <router-link :to="linksPath+'1'" aria-label="Iniciar el curso">
        <ui-button-circle-secondary aria-hidden="true" class="animated bounceIn dura_1" aria=""></ui-button-circle-secondary>
      </router-link>
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    color() {
      return this.$store.state.color;
    },
    linksPath() {
      return this.$store.state.linksPath;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// Inicio.vue?49704224